import { safeFetch } from "../utils/safeFetch";

export const getAllPackages = async (token, tenant) => {
  const response = await safeFetch(`/api/packages`, {
    headers: {
      Authorization: `Bearer ${token}`,
      "x-tenant-id": tenant,
    },
  });

  if (!response.ok) {
    if (response.status === 0) throw new Error("Impossibile connettersi al server");
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return await response.json();
};

export const getAllPackagesByNow = async (token, tenant) => {
  const response = await safeFetch(`/api/packages/by-now`, {
    headers: {
      Authorization: `Bearer ${token}`,
      "x-tenant-id": tenant,
    },
  });

  if (!response.ok) {
    if (response.status === 0) throw new Error("Impossibile connettersi al server");
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return await response.json();
};

export const createPackage = async (payload, token, tenant) => {
  const response = await safeFetch(`/api/packages/create`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      "x-tenant-id": tenant,
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    if (response.status === 0) throw new Error("Impossibile connettersi al server");
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return await response.json();
};

export const updatePackage = async (packageId, payload, token, tenant) => {
  const response = await safeFetch(`/api/packages/${packageId}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      "x-tenant-id": tenant,
    },
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    if (response.status === 0) throw new Error("Impossibile connettersi al server");
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return await response.json();
};

export const deletePackageById = async (packageId, token, tenant) => {
  const response = await safeFetch(`/api/packages/${packageId}`, {
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${token}`,
      "x-tenant-id": tenant,
    },
  });

  if (!response.ok) {
    if (response.status === 0) throw new Error("Impossibile connettersi al server");
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  if (response.status === 204) return null;
  const text = await response.text();
  return text ? JSON.parse(text) : null;
};

export const uploadPackageImage = async (file, token, tenant) => {
  const fd = new FormData();
  fd.append("image", file);

  const response = await safeFetch(`/api/packages/upload-image`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
      "x-tenant-id": tenant,
    },
    body: fd,
  });

  if (!response.ok) {
    if (response.status === 0) throw new Error("Impossibile connettersi al server");
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return await response.json();
};
